import React from 'react'
import { connect } from "react-redux";
import { SetCopyKey } from '$Deposits/store/actions/DepositAction'
import { GetParamsData } from '$Deposits/lib/LibCommonData'
import copy from 'copy-to-clipboard';

export class CopyView extends React.Component {
    constructor(props) {
        super(props);
        this.copyActiveRef = React.createRef();
    }

    componentWillUnmount() {
        this.props.SetCopyKey('')
    }

    copys = () => {
        try {
            const value = String(this.props.copyValue)
            copy(value)
            const { toastTip } = GetParamsData()
            toastTip.success('Sao Chép Thành Công')

            this.props.SetCopyKey(this.props.copyType)

            // Show the copyActive span
            if (this.copyActiveRef.current) {
                this.copyActiveRef.current.style.display = 'inline';
            }
        } catch (error) {
            console.error('Copy failed:', error);
        }
    }

    render() {
        const { copyValue, copyTitle, copyType, redTip, bankCode } = this.props
        const showCopyIcon = copyType !== "accountHolderName" && copyType !== "bankName";

        return (
            <>
                <div className='paymentData'>
                    {
                        copyTitle && <div><span className='paymentTitle'>{copyTitle}</span>{redTip ? <span className='redTips'>Bắt Buộc</span> : null}</div>
                    }
                    <div className='paymentItem' style={{position: 'relative'}}>
                        <span className={`paymentValue ${copyType}`}>
                            {(copyType === 'money' || copyType === 'uniqueAmount') && '฿ '}
                            {copyValue}
                        </span>
                        {showCopyIcon ? (
                            <>
                                <span className='copyIcon' onClick={this.copys} />
                                <span className='copyActive' ref={this.copyActiveRef} style={{display: 'none', position: 'absolute', right: '-20px'}} />
                            </>
                        ) : (
                            <div style={{width:"23px"}}/>
                        )}
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = state => ({
    CopyKey: state.CopyKey,
});
const mapDispatchToProps = {
    SetCopyKey: (data = '') => SetCopyKey(data),
};
export default connect(mapStateToProps, mapDispatchToProps)(CopyView);